/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Link_React_Native_SetupInputs */

const en_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React Native Setup`)
};

const ar_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعداد React Native`)
};

const bn_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React Native সেটআপ`)
};

const de_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natives Setup reagieren`)
};

const es_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaccionar configuración nativa`)
};

const fr_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuration native de React`)
};

const pt_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configuração nativa do React`)
};

const zh_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`React Native 设置`)
};

const tr_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yerel Kuruluma Tepki Ver`)
};

const ru_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка React Native`)
};

const pl_quick_link_react_native_setup = /** @type {(inputs: Quick_Link_React_Native_SetupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reaguj na konfigurację natywną`)
};

/**
* | output |
* | --- |
* | "React Native Setup" |
*
* @param {Quick_Link_React_Native_SetupInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const quick_link_react_native_setup = /** @type {((inputs?: Quick_Link_React_Native_SetupInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Link_React_Native_SetupInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_quick_link_react_native_setup(inputs)
	if (locale === "bn") return bn_quick_link_react_native_setup(inputs)
	if (locale === "de") return de_quick_link_react_native_setup(inputs)
	if (locale === "es") return es_quick_link_react_native_setup(inputs)
	if (locale === "fr") return fr_quick_link_react_native_setup(inputs)
	if (locale === "pt") return pt_quick_link_react_native_setup(inputs)
	if (locale === "zh") return zh_quick_link_react_native_setup(inputs)
	if (locale === "tr") return tr_quick_link_react_native_setup(inputs)
	if (locale === "ru") return ru_quick_link_react_native_setup(inputs)
	if (locale === "pl") return pl_quick_link_react_native_setup(inputs)
	return en_quick_link_react_native_setup(inputs)
});